// Google Tag Manager helpers.
// The GTM container itself (GTM-M432H7DS) is bootstrapped in `_document.tsx`;
// everything here just pushes events onto the dataLayer for GTM to pick up.

type DataLayerEvent = {
  event: string;
  [key: string]: unknown;
};

export const pushToDataLayer = (payload: DataLayerEvent) => {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(payload);
};

// The "book a demo" funnel, from the CTA click through to a confirmed meeting.
// Use these names when building triggers/conversions inside GTM.
export const BOOK_DEMO_EVENTS = {
  /** A "Book a demo" button was clicked anywhere on the site. */
  ctaClick: "book_demo_cta_click",
  /** The /book-a-demo page was opened. */
  pageView: "book_demo_page_view",
  /** The HubSpot scheduler finished loading and is ready to interact with. */
  schedulerLoaded: "book_demo_scheduler_loaded",
  /** A meeting was actually booked — this is the conversion event. */
  meetingBooked: "book_demo_meeting_booked",
} as const;

// The NRF 2026 Europe landing page (/nrf). The booking itself still reports
// through BOOK_DEMO_EVENTS above — these only cover what is specific to the
// campaign, so GTM can attribute demos back to the show.
export const NRF_EVENTS = {
  /** The /nrf page was opened, with the resolved hero state and campaign source. */
  pageView: "nrf_page_view",
  /** Any CTA on /nrf was clicked. */
  ctaClick: "nrf_cta_click",
  /** The session .ics was downloaded. */
  addToCalendar: "nrf_add_to_calendar",
  /** The lead form was submitted successfully — this is the conversion event. */
  lead: "nrf_lead",
  /** The slides pop-up was shown after the calendar download. */
  slidesPromptOpen: "nrf_slides_prompt_open",
  /** An email was left in the slides pop-up — a lead in its own right. */
  slidesLead: "nrf_slides_lead",
} as const;
